module.exports = __webpack_public_path__ + "static/media/kia-go-drive.22647a06.jpg";